import { useQuery } from '@apollo/client';
import type { Community } from '@communities/community/domain';
import { GET_COMMUNITIES_IN_GROUP } from '@communities/community/graphql';
import { useCurrentCommunityGroupId } from '@communities/community-groups/hooks';
import { transformErrors } from '@core/adapters/errors';
import type { DomainError } from '@core/domain';
import { useMemo } from 'react';

interface CommunitiesResponse {
  communities: {
    communities: Community[];
    isAdmin: boolean;
  };
}

export function useCommunities() {
  const communityGroupId = useCurrentCommunityGroupId();

  const { data, loading, error, refetch } = useQuery<CommunitiesResponse>(GET_COMMUNITIES_IN_GROUP, {
    variables: { communityGroupId },
    skip: !communityGroupId,
    fetchPolicy: 'cache-first',
  });

  const communities = data?.communities?.communities || [];

  const errors: DomainError[] | null = useMemo(() => {
    if (!error) return null;

    return transformErrors(error);
  }, [error]);

  return {
    data: communities,
    loading,
    errors,
    refetch,
  };
}

export default useCommunities;
